<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1200px' }">
      <v-flex xs12 lg12 md12>
        <v-layout wrap>
          <v-card class="no-background no-shadow">
            <v-card-text class="user-title">
              Hello, {{ user.name }}
            </v-card-text>
            <v-card-text class="user-description">
              Welcome back!
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-layout row wrap class="mb-3">
        <v-flex xs12 lg12 md12>
          <AccountValue :account-values="accountValues"></AccountValue>
        </v-flex>

        <v-flex xs12 lg12 md12>
          <TradeEngineStatus></TradeEngineStatus>
        </v-flex>

        <v-flex xs12 md6 lg6>
          <AccountValueChartWrapper
            title="Total account value"
            :btc="accountValueHistory.BTC"
            :usd="accountValueHistory.USD"
          ></AccountValueChartWrapper>
        </v-flex>

        <v-flex xs12 md6 lg6>
          <GraphProfitTradeWrapper></GraphProfitTradeWrapper>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <BaseCurrencies></BaseCurrencies>
        </v-flex>
      </v-layout>

      <v-dialog v-model="shareDialogOpen" lazy max-width="750px" scrollable>
        <Share :metric="shareMetric" @close-dialog="shareDialogOpen = false" />
      </v-dialog>

      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-card-text class="pa-32">
              <v-layout align-center justify-center row fill-height wrap>
                <v-flex xs6>
                  <h2 class="title mb-2">Recent trade history</h2>
                </v-flex>
                <v-flex
                  v-if="user"
                  xs6
                  class="text-xs-right mt-4 share-description"
                >
                  Completed trade pairs today:
                  <v-btn class="btn-share" round @click="shareTotalTrades">
                    {{ this.profitableTradesToday }}
                    <v-icon right small>fas fa-share-alt</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="tradeValueHistoryHeaders"
                :items="tradeValueTrades"
                :disable-initial-sort="true"
                item-key="sell_order_uuid_hash"
                :pagination.sync="pagination"
                :loading="loading"
                :total-items="totalTradeValueTrades"
                :rows-per-page-items="[5, 10, 25]"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable text-xs-left',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : ''
                      ]"
                      :aria-sort="
                        pagination.descending ? 'descending' : 'ascending'
                      "
                      @click="changeSort(header)"
                    >
                      {{ header.text }}
                      <v-icon small>arrow_upward</v-icon>
                      <v-icon
                        v-if="header.value == 'profit_usd'"
                        class="vertical-align-middle icon-for-information"
                        style="font-size: 16px; opacity: 1; transform: none !important; -webkit-transform: none !important;"
                        @click.stop.prevent
                        @click="
                          () => {
                            infoAlert(
                              $t('information.profit_worth_usd.title'),
                              $t('information.profit_worth_usd.description')
                            );
                          }
                        "
                        >fa-info-circle</v-icon
                      >
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr
                    :style="{ cursor: 'pointer' }"
                    @click="e => (props.expanded = !props.expanded)"
                  >
                    <td>
                      {{
                        props.item.ts_closed_utc
                          | formatDate("DD MMM YYYY HH:mm")
                      }}
                    </td>
                    <td>
                      <v-img
                        :src="'/img/' + props.item.exchange_name + '_logo.svg'"
                        width="20"
                        height="20"
                        class="ml-3"
                        :alt="props.item.exchange_name"
                      ></v-img>
                    </td>
                    <td>
                      {{ props.item.target_currency }}/{{
                        props.item.base_currency
                      }}
                    </td>
                    <td>
                      {{
                        props.item.quantity
                          ? props.item.quantity.toString().substring(0, 9)
                          : 0
                      }}
                    </td>
                    <td
                      v-if="
                        props.item.quantity !==
                          props.item.surplus_quantity_total
                      "
                    >
                      <v-btn
                        small
                        flat
                        style="margin: 6px 0px; padding: 0px;"
                        @click.stop="shareSingleTrade(props.item.uuid)"
                      >
                        {{ props.item.base_currency }}
                        {{ props.item.profit.toFixed(8) }}
                        <v-icon right small>fas fa-share-alt</v-icon>
                      </v-btn>
                    </td>
                    <td
                      v-if="
                        props.item.quantity !==
                          props.item.surplus_quantity_total
                      "
                      style="text-align: right; padding-right: 62px;"
                    >
                      {{ props.item.profit_percentage.toFixed(2) }}
                    </td>
                    <td v-else>{{ $t("not_applicable") }}</td>
                    <td style="text-align: right; padding-right: 92px;">
                      {{ props.item.profit_usd.toFixed(2) }}
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <TradeDetails
                    :sell-order="props.item"
                    :base-currency="props.item.base_currency"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.vertical-align-middle {
  vertical-align: middle;
}
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
>>> .theme--light.v-sheet {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
}
>>> .theme--dark.v-sheet {
  background: #212121;
  border-radius: 15px;
}
>>> .theme--light .v-card__text h2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
  color: #103a84;
}
>>> .theme--dark .v-card__text h2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
}
>>> .theme--dark.v-list {
  color: #fff;
  background: transparent;
}
.no-shadow {
  box-shadow: none !important;
}
.no-background {
  background: transparent !important;
}
.theme--light .user-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
  color: #103a84;
}
.theme--light .user-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
  padding-top: 0px;
  padding-bottom: 40px;
}

.theme--dark .user-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
}
.theme--dark .user-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 0px;
  padding-bottom: 40px;
}

>>> .theme--light.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
>>> .theme--light.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
>>> .theme--light.v-datatable thead th.column.sortable.active,
>>> .theme--light.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--light.v-datatable thead th.column.sortable:hover {
  color: #103a84;
}
>>> .theme--light .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #7395d0;
}
>>> .theme--light .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84 !important;
  max-height: 24px;
}

>>> .theme--light
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  padding-left: 8px;
}

>>> .theme--light .v-datatable__actions .v-input__slot {
  border: 0.8px solid #103a84;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::after,
>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  width: 0px;
}
>>> .theme--light .v-datatable__actions .v-btn {
  color: #103a84;
}
>>> .theme--light.v-btn.v-btn--disabled,
>>> .theme--light.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--light.v-btn.v-btn--disabled .v-icon {
  color: #b8d2ff !important;
}

>>> .v-datatable__actions .theme--light.v-icon {
  color: #103a84 !important;
}

>>> .v-datatable__actions .v-input__append-inner {
  margin-top: 0px !important;
}
>>> .theme--dark.v-table {
  background: #212121;
}
>>> .theme--dark.v-datatable .v-datatable__actions {
  background: #212121;
}
>>> .theme--dark.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}
>>> .theme--dark.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
>>> .theme--dark.v-datatable thead th.column.sortable.active,
>>> .theme--dark.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--dark.v-datatable thead th.column.sortable:hover {
  color: #ffffff;
}
>>> .theme--dark .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  max-height: 24px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 8px;
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions .v-input__slot {
  border: 0.8px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}
>>> .v-datatable__actions .theme--dark.v-icon {
  color: #ffffff !important;
}
>>> .theme--dark.v-btn.v-btn--disabled,
>>> .theme--dark.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--dark.v-btn.v-btn--disabled .v-icon {
  color: rgba(235, 235, 245, 0.6) !important;
}

.theme--light .btn-share {
  background-color: #103a84 !important;
  color: #ffffff !important;
}
.theme--light .share-description {
  color: #103a84 !important;
}

>>> .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-table tbody tr:not(:first-child) {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__actions {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__expand-col--expanded {
  border-bottom: 1px solid #e6efff;
}
.pa-32 {
  padding: 32px;
}
</style>

<script>
import { mapGetters } from "vuex";
import AccountInfo from "~/components/dashboard/AccountInfo";
import ChartWrapper from "~/components/dashboard/ChartWrapper";
import AccountValueChartWrapper from "~/components/dashboard/AccountValueChartWrapper";
import GraphProfitTradeWrapper from "~/components/dashboard/GraphProfitTradeWrapper";
import AccountValue from "~/components/dashboard/AccountValue";
import BaseCurrencies from "~/components/dashboard/BaseCurrencies";
import TradeDetails from "~/components/dashboard/TradeDetails";
import TradeEngineStatus from "~/components/dashboard/TradeEngineStatus";
import swal from "sweetalert2";
import axios from "axios";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import Share from "../components/dashboard/Share";

export default {
  metaInfo() {
    return { title: this.$t("page-dashboard") };
  },
  components: {
    Share,
    AccountInfo,
    ChartWrapper,
    GraphProfitTradeWrapper,
    AccountValue,
    BaseCurrencies,
    TradeDetails,
    TradeEngineStatus,
    AccountValueChartWrapper
  },
  data: function() {
    return {
      loading: true,
      totalTradeValueTrades: 0,
      tradeValueTrades: [],
      tradeValueHistoryHeaders: [
        {
          text: `Date time (${moment()
            .tz(moment.tz.guess())
            .format("z")})`,
          value: "ts_closed_utc"
        },
        {
          text: "Exchange",
          value: "exchange_name"
        },
        { text: "Trade pair", value: "base_currency" },
        { text: "Quantity", value: "quantity" },
        { text: "Profit", value: "profit" },
        { text: "Profit (%)", value: "profit_percentage" },
        { text: "Profit worth (USD)", value: "profit_usd" }
      ],
      pagination: {
        descending: true,
        sortBy: null,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0
      },
      shareDialogOpen: false,
      addManualBuyOrderDialogOpened: false,
      shareMetric: null
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      profitTradeHistoryData: "accountValue/profit_trades_last_week",
      accountValueHistory: "accountValue/account_value_history",
      themeDark: "settings/darkmode",
      accountValues: "accountValue/values",
    }),
    profitableTradesToday: function() {
      let ts = moment()
        .tz(moment.tz.guess())
        .format("YYYY-MM-DD");

      if (!this.profitTradeHistoryData[ts]) {
        return 0;
      }
      return this.profitTradeHistoryData[ts].count;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    }
  },
  created: async function() {
    await this.getDataFromApi();
    await this.$store.dispatch("accountValue/fetchAll");
  },
  methods: {
    async getDataFromApi() {
      this.loading = true;
      let params =
        "?descending=" +
        this.pagination.descending +
        "&sortBy=" +
        this.pagination.sortBy +
        "&page=" +
        this.pagination.page +
        "&rowsPerPage=" +
        this.pagination.rowsPerPage +
        "&totalItems=" +
        this.pagination.totalItems;
      await axios
        .get("/api/v1/trade/closed" + params)
        .then(res => {
          this.tradeValueTrades = res.data.items;
          this.totalTradeValueTrades = res.data.total;
          this.loading = false;
        })
        .catch(error => {
          this.tradeValueTrades = [];
          this.totalTradeValueTrades = 0;
          this.loading = false;
        });
    },
    shareTotalTrades() {
      this.shareMetric = "trades-per-day";
      this.shareDialogOpen = true;
    },
    shareSingleTrade(tradeId) {
      this.shareMetric = tradeId;
      this.shareDialogOpen = true;
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    changeSort: function(header) {
      this.pagination.sortBy = header.value;
      this.pagination.descending = !this.pagination.descending;
    },
    closeDialogForManualBuy() {
      this.addManualBuyOrderDialogOpened = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/dashboard.vue